import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CoursesListView from './CoursesListView';

/** Eigene Seite: nur aktive / ausgebuchte Kurse. */
export default function CoursesActiveList() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (params.get('status') === 'inactive') {
      navigate('/courses/inactive', { replace: true });
    }
  }, [params, navigate]);

  return <CoursesListView mode="active" />;
}
